import { useMediaQuery } from '@firsttable/react-hooks';
import { breakpointsObject } from './breakpoints';

export type ViewportTier = 'mobile' | 'tablet' | 'desktop';

/**
 * Viewport tier derived from the theme breakpoints (the single source of truth), so it always tracks the points the layout actually pivots on:
 * - `mobile`:  width < `s` (784px)
 * - `tablet`:  `s` <= width < `m` (784–1023px)
 * - `desktop`: width >= `m` (1024px)
 *
 * This is viewport classification, not hardware/device detection.
 */
export default function useViewportTier(): ViewportTier {
  const isAtLeastTablet = useMediaQuery(`(min-width: ${breakpointsObject.s})`);
  const isAtLeastDesktop = useMediaQuery(`(min-width: ${breakpointsObject.m})`);

  if (isAtLeastDesktop) {
    return 'desktop';
  }
  if (isAtLeastTablet) {
    return 'tablet';
  }
  return 'mobile';
}
